import React from 'react';
import { ArrowUpRightIcon, RefreshCwIcon, StarIcon } from 'lucide-react';
import { recentWork, socials } from '../data/site';
const reviewLink = socials.find(s => s.label === 'SureCritic')?.href ?? '#';
export function Reviews() {
  return <section id="reviews" className="w-full bg-white py-20 lg:py-28" data-id="element-130" data-mp="2madu3w86zyuo">
      <div className="mx-auto max-w-shell px-5 lg:px-8" data-id="element-131" data-mp="2rbtf5oade5d2">
        <div className="grid gap-12 lg:grid-cols-[minmax(0,380px)_minmax(0,1fr)] lg:gap-16" data-id="element-132" data-mp="2w9uxu83vw2o0">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-133" data-mp="2w81zrh7c6qrm">
            <p className="text-[12px] font-bold uppercase tracking-[0.18em] text-brand-dark" data-id="element-134" data-mp="309x1unx3d86g">
              Reputation
            </p>
            <h2 className="mt-4 font-display text-[34px] font-extrabold leading-[1.08] tracking-[-0.02em] text-ink sm:text-[40px]" data-id="element-135" data-mp="354j6m88o42hk">
              Rated by the people we actually served
            </h2>

            <div className="mt-8 rounded-xl border border-black/10 bg-chalk p-7" data-id="element-136" data-mp="3jzgxsxs2ylx2">
              <div className="flex items-baseline gap-3" data-id="element-137" data-mp="3jxcxsqxay722">
                <span className="font-display text-[52px] font-extrabold leading-none tracking-tight text-ink" data-id="element-138" data-mp="2rdozxhv8v740">
                  5.0
                </span>
                <span className="text-[15px] font-medium text-steel/60" data-id="element-139" data-mp="2hehr97zgg0n8">
                  from 92 reviews
                </span>
              </div>
              <div className="mt-3 flex gap-1" aria-hidden="true" data-id="element-140" data-mp="2de7jbps3r05q">
                {Array.from({
                length: 5
              }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-brand text-brand" data-id="element-141" data-mp="3a59gfli3rp12" data-mpi={i} />)}
              </div>
              <p className="mt-4 text-[14.5px] leading-relaxed text-steel/70" data-id="element-142" data-mp="30dc60gyx513e">
                Verified through SureCritic, which collects feedback directly
                from customers after service. Review feed placeholder — the
                live rating and individual reviews can be connected during
                build.
              </p>
              <a href={reviewLink} target="_blank" rel="noreferrer" className="mt-5 inline-flex items-center gap-1.5 text-[14px] font-semibold text-brand-dark hover:underline" data-id="element-143" data-mp="3o24tdp1h60me">
                Read reviews on SureCritic
                <ArrowUpRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-144" data-mp="1cetaplxznv0t" />
              </a>
            </div>
          </div>

          <div data-id="element-145" data-mp="1hckzw879131b">
            <div className="flex items-center justify-between gap-4 border-b border-black/10 pb-4" data-id="element-146" data-mp="1hcbbgp1ur3xq">
              <h3 className="font-display text-xl font-bold tracking-tight text-ink" data-id="element-147" data-mp="18dzl8o4we85t">
                Recently in the shop
              </h3>
              <span className="inline-flex items-center gap-1.5 whitespace-nowrap text-[12px] font-semibold uppercase tracking-[0.08em] text-steel/50" data-id="element-148" data-mp="ths3dugypitp">
                <RefreshCwIcon className="h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-149" data-mp="yhmr5p5fxsaj" />
                Feed placeholder
              </span>
            </div>

            <ul className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-150" data-mp="2ssjgcx4rarck">
              {recentWork.map(item => <li key={item.title} className="flex flex-col overflow-hidden rounded-lg border border-black/10 bg-white" data-id="element-151" data-mp="h6qydcag0o7n">
                  <img src={item.image} alt={`${item.title} at East End Automotive Repair`} className="aspect-[4/3] w-full object-cover" data-id="element-152" data-mp="qx2h44ysd1yl" />
                  <div className="flex flex-1 flex-col p-5" data-id="element-153" data-mp="zv5ps0ooa48z">
                    <h4 className="font-display text-[16px] font-bold leading-snug tracking-tight text-ink" data-id="element-154" data-mp="vw58imluf9o3">
                      {item.title}
                    </h4>
                    <p className="mt-2 text-[13.5px] leading-relaxed text-steel/65" data-id="element-155" data-mp="14w2314uwz2r2">
                      {item.caption}
                    </p>
                    <span className="mt-auto flex items-center gap-1.5 pt-4 text-[12px] font-semibold uppercase tracking-[0.08em] text-brand-dark" data-id="element-156" data-mp="3bnb0mx04pfnd">
                      <StarIcon className="h-3.5 w-3.5 shrink-0 fill-brand text-brand" aria-hidden="true" data-id="element-157" data-mp="384lzp3hnc6zr" />
                      Post-service review slot
                    </span>
                  </div>
                </li>)}
            </ul>

            <p className="mt-6 text-[13.5px] text-steel/55" data-id="element-158" data-mp="3n2e9rg4fc36k">
              Placeholder layout — individual customer reviews and recent
              service photos can be connected during build.
            </p>
          </div>
        </div>
      </div>
    </section>;
}